// Types
import type { TIconColor, TIconName, TIconNameAlias, TIconNameReal, TIconProps, TIconSize } from './Icon.type';

export const ICON_SIZES: TIconSize[] = ['xs', 'sm', 'md', 'lg', 'xl'];
export const ICON_SIZE: { [key in TIconSize]: key } = {
	xs: 'xs',
	sm: 'sm',
	md: 'md',
	lg: 'lg',
	xl: 'xl'
};

export const ICON_COLORS: TIconColor[] = [
	'primary',
	'secondary',
	'tertiary',
	'success',
	'warning',
	'error',
	'information'
];
export const ICON_COLOR: { [key in TIconColor]: key } = {
	primary: 'primary',
	secondary: 'secondary',
	tertiary: 'tertiary',
	success: 'success',
	warning: 'warning',
	error: 'error',
	information: 'information'
};

export const ICON_NAME_REAL: { [key in TIconNameReal]: key } = {
	['arrow-down']: 'arrow-down',
	['arrow-left']: 'arrow-left',
	['arrow-right']: 'arrow-right',
	['arrow-up']: 'arrow-up',
	['bold']: 'bold',
	['brand-android']: 'brand-android',
	['brand-apple']: 'brand-apple',
	['brand-facebook']: 'brand-facebook',
	['brand-github']: 'brand-github',
	['brand-gitlab']: 'brand-gitlab',
	['brand-instagram']: 'brand-instagram',
	['brand-linkedin']: 'brand-linkedin',
	['brand-react']: 'brand-react',
	['brand-telegram']: 'brand-telegram',
	['brand-whatsapp']: 'brand-whatsapp',
	['brand-x']: 'brand-x',
	['brand-youtube']: 'brand-youtube',
	['calendar']: 'calendar',
	['check']: 'check',
	['check-circle']: 'check-circle',
	['chevron-down']: 'chevron-down',
	['chevron-left']: 'chevron-left',
	['chevron-right']: 'chevron-right',
	['chevron-up']: 'chevron-up',
	['clipboard']: 'clipboard',
	['clock']: 'clock',
	['copy']: 'copy',
	['cross']: 'cross',
	['cross-circle']: 'cross-circle',
	['database']: 'database',
	['dots']: 'dots',
	['dots-vertical']: 'dots-vertical',
	['download']: 'download',
	['exclamation-mark']: 'exclamation-mark',
	['exclamation-mark-circle']: 'exclamation-mark-circle',
	['exclamation-mark-triangle']: 'exclamation-mark-triangle',
	['eye']: 'eye',
	['eye-off']: 'eye-off',
	['floppy-disk']: 'floppy-disk',
	['gear']: 'gear',
	['heart']: 'heart',
	['heart-filled']: 'heart-filled',
	['home']: 'home',
	['inbox']: 'inbox',
	['info-circle']: 'info-circle',
	['italic']: 'italic',
	['legion']: 'legion',
	['location']: 'location',
	['mail']: 'mail',
	['mail-opened']: 'mail-opened',
	['menu']: 'menu',
	['message']: 'message',
	['minus']: 'minus',
	['pencil']: 'pencil',
	['phone']: 'phone',
	['photo']: 'photo',
	['plus']: 'plus',
	['question-mark']: 'question-mark',
	['refresh']: 'refresh',
	['send']: 'send',
	['star']: 'star',
	['star-filled']: 'star-filled',
	['star-half']: 'star-half',
	['trash']: 'trash',
	['underline']: 'underline',
	['upload']: 'upload',
	['user']: 'user',
	['users']: 'users',
	['video']: 'video',
	['zoom']: 'zoom',
	['zoom-in']: 'zoom-in',
	['zoom-out']: 'zoom-out',
};

export const ICON_NAME_ALIAS: { [key in TIconNameAlias]: key } = {
	['account']: 'account',
	['account-group']: 'account-group',
	['account-single']: 'account-single',
	['alert']: 'alert',
	['alert-circle']: 'alert-circle',
	['alert-triangle']: 'alert-triangle',
	['close']: 'close',
	['close-circle']: 'close-circle',
	['date']: 'date',
	['delete']: 'delete',
	['dots-horizontal']: 'dots-horizontal',
	['edit']: 'edit',
	['error']: 'error',
	['error-circle']: 'error-circle',
	['error-triangle']: 'error-triangle',
	['eye-on']: 'eye-on',
	['ellipsis']: 'ellipsis',
	['gallery']: 'gallery',
	['hamburger-menu']: 'hamburger-menu',
	['image']: 'image',
	['mail-closed']: 'mail-closed',
	['paste']: 'paste',
	['profile']: 'profile',
	['rating-empty']: 'rating-empty',
	['rating-filled']: 'rating-filled',
	['rating-half']: 'rating-half',
	['save']: 'save',
	['search']: 'search',
	['setting']: 'setting',
	['star-empty']: 'star-empty',
	['success']: 'success',
	['success-circle']: 'success-circle',
	['time']: 'time',
	['user-group']: 'user-group',
	['user-single']: 'user-single',
};

export const ICON_NAME: { [key in TIconName]: key } = {
	...ICON_NAME_REAL,
	...ICON_NAME_ALIAS
};

export const ICON_DEFAULT_PROPS: TIconProps = {
	icon: ICON_NAME.legion,
	color: ICON_COLOR.primary,
	size: ICON_SIZE.md,
};
